import {Injectable} from '@angular/core';
import {StorageKeysEnum} from "../../storage/storage-keys.enum";
import {UserPermissionEnum} from "../permissions/permission.enum";
import {UserUtilsService} from "../../services/user/user-utils.service";
import * as _ from "lodash";


@Injectable({providedIn: 'root'})
export class ContractsUtils {

    constructor(private userUtilsService: UserUtilsService) {
    }

    getContracts(contracts: any) {
        const contractsArray: any[] = [];
        if (contracts) {
            const parseContracts = JSON.parse(contracts)
            for (let key in parseContracts) {
                const contract = {
                    contract: key,
                };
                contractsArray.push(contract);

            }
        }
        return contractsArray;
    }

    getContractsForAddReceivers(contractsArray: any) {
        return contractsArray.filter((item: any) => item.services.includes(UserPermissionEnum.ADD_RECEIVER));
    }

    getContractsByServices() {
        const contractInformation = JSON.parse(sessionStorage.getItem(StorageKeysEnum.CONTRACTS_INFORMATION) ?? '{}');
        const contractsUser = contractInformation.contractsUser ?? [];
        const contractsFromToken = this.getContracts(sessionStorage.getItem(StorageKeysEnum.PERMISSIONS) ?? '').map(contract => contract.contract)
        return contractsUser?.filter((contract: any) => contractsFromToken.includes(contract?.idContrato));
    }

    completeContractsInformation(dashBoardContracts: any) {
        const contractInformationString = sessionStorage.getItem(StorageKeysEnum.CONTRACTS_INFORMATION)
        const contractInformation: any = contractInformationString ? JSON.parse(contractInformationString) : {};
        const needComplete = this.needToCompleteInformation(contractInformation);
        if (needComplete) {
            contractInformation.contractsUser = _.map(contractInformation?.contractsUser, (contract: any) => {
                const contractFound = dashBoardContracts.find((dashboardContract: any) => dashboardContract.contractId == contract.idContrato);
                contract['pfae'] = contractFound.pfae
                contract['nomina'] = contractFound.nomina
                return contract;
            });
            sessionStorage.setItem(StorageKeysEnum.CONTRACTS_INFORMATION, JSON.stringify(contractInformation))
        }
    }

    private needToCompleteInformation(contractInformation: any) {
        return (contractInformation &&
            contractInformation.contractsUser &&
            contractInformation.contractsUser.length > 0 &&
            (!_.has(contractInformation.contractsUser[0], 'nomina')
                || !_.has(contractInformation.contractsUser[0], 'pfae')))
    }


}
